export const routingActionCreator = (route: string, alternativeRoute?: string) => {
    return {
        type: route,
        backTo: alternativeRoute || null
    };
};
